<template>
    <div class="content-wrapper">
        <div class="content pure-u-11-12 info-container">
            <div class="sub-section">
                <h3 class="sub-header">Back to Bits | Level 1 - NES Nostalgia</h3>
                    <p>
                        Back to Bits, a curated animation project featuring the collective works of more than 40 artists from around the world, showcases a series of animated GIFs inspired by retro NES games. This first round, or “level,” in the Back to Bits series is called NES Nostalgia, and is a tribute to retro 80s and 90s NES games.
                    </p>
                    <p>
                        Back to Bits was channeled by the nostalgic desire to go 'back to the bit era' when games were measured in bits, NES 8-bit and SNES 16-bit.
                    </p>
                    <p>
                        The project serves as a lighthearted creative outlet to bring like-minded artists together to share work, celebrate their love for these games and inspire the next generation of gamers.
                    </p>
                    <p> 
                        Back to Bits contributors are professional artists from various creative industries including illustrators, animators, comic book artists, concept artists, directors and designers who share a passion for video games. Artists were asked to reinterpret and create a seamless looping animated short GIF inspired by an NES game of their choice.
                    </p>
                    <p>
                        Subsequent levels in this series are in development stages and are planned for future release.
                    </p>
            </div>

            <div class="sub-section">
               <h3 class="sub-header">Back to Bits | Level 1 - NES Nostalgia Montage</h3>
                    <iframe src="https://player.vimeo.com/video/191178799?byline=0&portrait=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>           
            </div>

            <div class="sub-section">
                <h3 class="sub-header">Games we were inspired by:</h3>
                <p>
                    720, Adventures of Lolo, Balloon Fight, Blaster Master, Bomberman, Burger Time, Castlevania, Donkey Kong, Double Dragon, Dr. Mario, Dragon Warrior, Duck Tales, Duckhunt, Excitebike, Fester’s Quest, Final Fantasy, Gauntlet, Joust, Kirby's Adventure, Legend of Kage, Lemmings, Marble Madness, Mega Man, Mega Man 2, Mega Man 3, Metroid, Mike Tyson’s Punchout, Mother/Earthbound, Ninja Gaiden, Nintendo World Cup, Pac Man, Paperboy, R.C. Pro-Am, Rampage, Spy Hunter, Super Mario Bros. 2, Super Mario Bros. 3, Tetris, Tetris 2, TMNT 2, Zelda 1 - The Legend of Zelda, Zelda 2 - The Adventure of Link
                </p>
            </div>

            <div class="sub-section press-inquiry">
                <h3 class="sub-header">Press & Inquiries: <a class="press-inquiry-link" href="mailto:hello@backtobits.com" target="_blank">hello@backtobits.com</a></h3>
            </div>

            <div class="sub-section">
                <h3 class="sub-header"><a href="http://backtobitspresskit.com.s3-website-us-east-1.amazonaws.com/" target="_blank">Our Press Kit</a></h3>
                <p>Follow us on <a href="https://www.instagram.com/backtobits/" target="_blank">Instagram</a></p> 
            </div>

            <div class="sub-section">
                <h3 class="sub-header">Credits</h3>
                <p>Created & Curated by: <a href="http://www.jerryliustudio.com/" target="_blank">Jerry Liu</a></p>
                <p>Co-Produced with: <span class="sub-author">Angela Liu</span></p> 
                <p>Website developed by: <span class="sub-author">Peter Chi</span></p>
                <p>Music & Sound Design by: <a href="http://www.sonosanctus.com" target="_blank">Wesley Slover</a></p>
                <p>Special thanks to: <a href="http://www.albertcreativeservices.com/" target="_blank">Jennifer Ortiz</a></p>
            </div>

        <div class="footer l-box">
            &copy; 2016 All Rights Reserved. Do not use without contacting Back to Bits for permission. Images may not be used without permission of the artist(s).        
        </div>
        </div>
    </div>

</template>

<script>
    export default {
      name: 'Info',
      data () {
        return {}
      }
    }
</script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.info-container {
  color: #333;
}

.info-container h3, .info-container a {
  color: #f21852;
  margin: 30px 0;
}

.info-container p {
  font-size: 16px;
  line-height: 1.3em;
}

.info-container a:hover {
  color: #F9517E
}

.info-container .sub-section .press-inquiry-link {
  text-decoration: none;
  color: #333;
}

.info-container .sub-section a.press-inquiry-link:hover {
  text-decoration: underline;
  color: #666;
}

.info-container .sub-section .sub-author {
  color: #f21852;
}

</style>



// WEBPACK FOOTER //
// src/components/Info.vue